import fetch from '../fetch'
// import { xssSanitize as sanitize } from '@bt-react/libs/sanitize'

/* eslint-disable no-empty */
export interface ValidateTopics {
  title: string
  url: string
}

/**
 * Takes the string of keywords and breaks it out into a string array of topics
 * @param keywords 
 */
function splitKeywords (keywords: string): string[] {

  return (keywords ?? '')
    .replace(/"/g, '')
    .split(',')
    .map(keyword => keyword.trim())
    .filter(keyword => keyword !== '')

}

/**
 * Replaces special chars and whitespace in the topic with a hyphen for the URL
 * @param topic 
 */
function sanitiseTopic (topic: string): string {

  return topic.toLowerCase().trim()
  .replace(/[^\w\s-]/g, '-')
  .replace(/[\s_-]+/g, '-')
  .replace(/^-+|-+$/g, '')

}

function getTopicURL (hostUrl = '', topic: string): string {

  return `${hostUrl || process.env.HOST}/topic/${topic}`

}

function getSearchURL (hostUrl = '', topic: string): string {

  return `${hostUrl || process.env.HOST}/search/?q=${topic}`

}

function checkTopic (hostUrl = '', topic): ValidateTopics {

  const sanitisedTopic = sanitiseTopic(topic)
  const topicURL = getTopicURL(hostUrl, sanitisedTopic)
  const valid = true

  /**
   * Leaving this commented out for the time-being because somebody will change their mind again in a week
   */
  // let valid = false

  // try {

  //   const response = await fetch(topicURL)
  //   valid = response.status === 200 && !response.redirected

  // }
  // catch (e) {}

  return {
    title: topic,
    url: valid
      ? topicURL
      : getSearchURL(hostUrl, sanitisedTopic)
  }

}

/**
 * Takes a string of keywords and returns an array of Topics with URL
 * @param keywords 
 */
function validateTopics (hostUrl = '', keywords = ''): ValidateTopics[] {

  if (typeof keywords !== 'string') return []

  const topics = splitKeywords(keywords.trim())
  // return topics.map(topic => checkTopic(hostUrl, sanitize(topic)))
  return topics.map(topic => checkTopic(hostUrl, topic))

}

export default validateTopics
